import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'
import type { Dispatch, SetStateAction } from 'react'
type ConfigurationContextProps = {
  viewAt: Date
  viewAtString: string
  onViewAtChanged: (nextDate: Date) => void
  activeFPlusEditorId: Optional<string>
  setActiveFPlusEditorId: Dispatch<SetStateAction<Optional<string>>>
  isSearchActive: boolean
  onChangeSearchActive: (nextIsSearchActive: boolean) => void
}

const [useConfigurationContext, Provider] =
  createRequiredContext<ConfigurationContextProps>('Configuration')

export { Provider, useConfigurationContext }
